import { algoliaBlogPostsAdapter, blogPostsAdapter } from 'adapters/blog'
import ArticlesResults from 'components/shared/ArticlesResults'
import BlogNav from 'components/shared/BlogNav'
import Link from 'components/shared/Link'
import ProgressProvider from 'components/shared/ProgressProvider'
import { Seo, SeoProvider } from 'components/shared/Seo'
import { Label, Text, Title } from 'components/typo'
import RichText from 'components/typo/RichText'
import delve from 'dlv'
import React from 'react'
import { fetchArticlesGridPage, getDataDependencies } from 'services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

import { SINGLES } from 'services/constants'
import css from './styles.module.scss'
import fetchContentType from 'src/lib/Strapi/fetchContentType'
import spreadStrapiData from 'src/lib/Strapi/spreadStrapiData'

const BlogCategory = ({ pageData, articlesData, facetFilters, ...rest }) => {
  const newsletter = delve(rest, 'newsletter', null)
  const category = delve(pageData, '0', null)
  const seo = delve(category, 'seo', null)
  const defaultFacets = category && category.name ? facetFilters : ''

  return (
    <ProgressProvider>
      <SeoProvider pageSeo={seo}>
        <Seo />
      </SeoProvider>
      <BlogNav
        categories={delve(pageData, 'blogPostNavCategories')}
        current={category && category.slug}
        newsletter={newsletter}
      />
      <ArticlesResults
        key="blog"
        params="/blog"
        index="blog_posts"
        adapter={algoliaBlogPostsAdapter}
        newsletter={newsletter}
        initialData={{
          ...articlesData,
          defaultFacets,
        }}
      >
        {category && (
          <div className={css.head}>
            <div className={css.breadcrumb}>
              <Link className={css.link} href={`${SINGLES.blog.url}`}>
                <Text size="small">{SINGLES.blog.label}</Text>
              </Link>
              <Label className={css.slash}>/</Label>
              {category.name && (
                <Text className={css.name} size="small" theme="purple">
                  {category.name}
                </Text>
              )}
            </div>
            {category.name && (
              <Title className={css.title} size="big">
                {category.name}
              </Title>
            )}
            {category.description && (
              <RichText type="Text" text={category.description} />
            )}
          </div>
        )}
      </ArticlesResults>
    </ProgressProvider>
  )
}

export async function getServerSideProps({ query, res }) {
  // const globalData = await fetchSingleType('global')
  const slug = query.category
  const facetFilters =
    slug === 'tutorials' ? [`category.name:${slug}`] : `category.name:${slug}`
  const { articlesData, statusCode, pageData } = await fetchArticlesGridPage({
    query,
    apiPath: `/post-categories?filters[slug][$eq]=${slug}`,
    index: 'blog_posts',
    hitsPerPage: 10,
    facetFilters: facetFilters,
  })

  const blogPostNav = await fetchSingleType(
    'blog-post-nav?populate=post_categories.post_sub_categories'
  )
  const extendedData = await getDataDependencies(pageData)

  const logo = delve(pageData, 'settings.logo', null)

  const blogSingleType = await fetchSingleType('blog')
  const blogLogo = delve(blogSingleType, 'settings.logo', null)
  const hasCustomLogo = logo || blogLogo
  const settings = delve(pageData, 'settings', {})

  res.statusCode = statusCode
  const blogPostNavCategories = await spreadStrapiData(
    blogPostNav.post_categories
  )

  const limit = 10
  const params = `filters[featuredCategory][slug][$eq]=${slug}&sort[0]=publishedAt:desc`
  const blogPosts = await fetchContentType(
    'blog-posts',
    `${params}&pagination[start]=0&pagination[limit]=${limit}`
  )

  let tempArticles = articlesData
  if (blogPosts && blogPosts.length > 0) {
    const convertBlogPostsJson = JSON.parse(
      JSON.stringify(blogPostsAdapter(blogPosts))
    )
    tempArticles.hits = convertBlogPostsJson
  }

  return {
    props: {
      pageData: {
        ...extendedData,
        newsletter: delve(blogPostNav, 'newsletter') || null,
        blogPostNavCategories,
        ...(hasCustomLogo && {
          settings: {
            ...settings,
            logo: logo || blogLogo,
          },
        }),
      },
      articlesData: tempArticles,
      facetFilters,
      statusCode,
    },
  }
}

export default BlogCategory
